var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container[data-v-485e5e5d]{height:100%}.main-container .background-image[data-v-485e5e5d]{position:fixed;top:0;left:0;width:100%;height:100%;background:#fff url(" + escape(require("../static/background-image.jpg")) + ") no-repeat 50%;background-size:cover;z-index:-1}.main-container .main__row[data-v-485e5e5d]{margin:40px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-485e5e5d","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/main.vue
// module id = 209
// module chunks = 0